import React from 'react';
import {Link} from "react-router-dom";

//IMG
import mapzone from "../../../assets/img/content/search/map-zone.png";
import logo from "../../../assets/img/content/search/newlogo.png";

//CSS
import styles from "./SelectZoneDialog.module.less";

function SelectZoneDialog({visible,onAccept,t,language}) {

  if (!visible) return null;

  return (
    <div className={styles.selectzonewindows}>
      <div className={styles.header}>
        <div className={styles.logo}><img src={logo}/></div>
        <div className={styles.text}>{t('search.seleczone.Por favor, indicanos en que zona de la isla se aloja')}.</div>
      </div>

      <div className={styles.content}>
        <div className={styles.map}><img src={mapzone}/></div>
        <div className={styles.buttons}>
          <Link to={'/' + language + '/search/north'} onClick={onAccept}><div className={styles.buttonnorth}>{t('search.seleczone.Zona NORTE')}</div></Link>
          <Link to={'/' + language + '/search/south'}onClick={onAccept}><div className={styles.buttonsouth}>{t('search.seleczone.Zona SUR')}</div></Link>
        </div>
      </div>

    </div>
  );
}

export default SelectZoneDialog;
